import { Container, Grid } from '@toptal/picasso'
import React from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { resultChanged } from '../../actions'
import { IStoreState } from '../../utils'
import TextArea, { ChangeEventType } from '../TextArea'

interface IResultsProps {
  value: string
  onChange(event: ChangeEventType): void
}

export const Results: React.FunctionComponent<IResultsProps> = ({
  value,
  onChange
}) => {
  return (
    <Container bottom='medium'>
      <Grid justify='center' spacing={0}>
        <Grid.Item small={12} medium={8}>
          <TextArea value={value} onChange={onChange} />
        </Grid.Item>
      </Grid>
    </Container>
  )
}

const mapStateToProps = (state: IStoreState) => ({
  value: state.result
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onChange: (event: ChangeEventType) => {
    const { target } = event
    dispatch(resultChanged(target.value))
  }
})

const ResultsSmart = connect(mapStateToProps, mapDispatchToProps)(Results)

export default ResultsSmart
